import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {extendWithChildReservationsReducers} from './reducers/childReservationsReducers';
import {extendWithConnectionWorkdaysReducers} from './reducers/connectionWorkdaysReducers';
import {extendWithDetailsReducers} from './reducers/detailsReducers';
import {extendWithParentReservationsReducers} from './reducers/parentReservationsReducers';
import {extendWithWorkdayReducers} from './reducers/workdayReducers';
import {extendWithWorkspaceReservationsReducers} from './reducers/workspaceReservationsReducers';
import {TimeslotsState} from './stateTypes';
import {extendWithConnectionWorkspaceReservationsReducers} from './reducers/connectionWorkspaceReservationsReducer';
import {extendWithReservationCountReducers} from './reducers/availabilityReducers';

export const timeslotsSlice = createSlice({
  name: 'timeslots',
  initialState: <TimeslotsState>{
    workdaysByDate: {},
    workspaceReservationsByDate: {},
    workspaceReservationCounts: {},

    connectionWorkdaysByDate: {},
    connectionWorkspaceReservationsByDate: {},

    childReservations: {},
    parentReservations: {},

    pendingMutations: [],
    pendingDetailRequests: [],
  },

  reducers: {
    clearAllChildReservations: (state) => {
      state.childReservations = {};
    },
  },
  extraReducers(builder) {
    extendWithWorkdayReducers(builder);
    extendWithWorkspaceReservationsReducers(builder);
    extendWithParentReservationsReducers(builder);
    extendWithChildReservationsReducers(builder);
    extendWithConnectionWorkdaysReducers(builder);
    extendWithDetailsReducers(builder);
    extendWithConnectionWorkspaceReservationsReducers(builder);
    extendWithReservationCountReducers(builder);
  },
});
